<div class="spinner-overlay" [hidden]="!(sectionLoader$ | async)">
  <mat-progress-spinner
    class="spinner-overlay__spinner"
    [color]="'primary'"
    [mode]="'indeterminate'"
    [value]="60">
  </mat-progress-spinner>
</div>
<router-outlet></router-outlet>
